module.exports = __webpack_public_path__ + "img/TN.26c30800.png";